<template>
      <region-popup @local-selected="checkLocale(true)"></region-popup>
</template>

<script>
    import { mapActions } from "vuex";
    import RegionPopup from "@/components/RegionPopup.vue"; 
    import { storage, isIE, subdomain } from "@/utils";
    
    export default {
        components: {
            RegionPopup
        },
        mounted()
        {
            //http://localhost:8080/set-region/it-it
            let regionToSet = this.$route.params.region.toLowerCase();
            if(regionToSet && regionToSet.length>0)
            {                
                //CHECK REQUESTED REGION:
                let regList = APP_CONFIG.APP_ALLOWED_REGIONS;

                //IF APP_CONFIG.APP_ALLOWED_REGIONS HAS ITEMS THEN CHECK:
                //(IF EMPTY [] ARRAY SO ALLOW ALL)
                if(regList.length>0)
                {
                    let allowedIndex = regList.findIndex(x => x === regionToSet);                
                    if(allowedIndex<0){
                        regionToSet = "en";//if requested locale is not allowed, set to default en
                    }
                }

                this.setLocale(regionToSet);                
                storage.set(`MIS-locale`, regionToSet, localStorage);
                let localeFromStorage = storage.get(`MIS-locale`, localStorage);

                if(regionToSet=='en'){
                    this.$router.push("/");
                }else{
                    this.$router.push("/"+localeFromStorage);
                }
            }            
        },
        methods:
        {
            ...mapActions(["setLocale"]),
            checkLocale(skip, _path) {
                let localeFromStorage = storage.get(`MIS-locale`, localStorage);
                //alert("localeFromStorage="+localeFromStorage);
                this.$router.push("/"+localeFromStorage);
            }
        }
    }
</script>

<style lang="stylus" scoped>
</style>
